import { useToken } from '@2r/frontend-component-library';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useValidateLogin() {
    const token = useToken();
    const navigate = useNavigate();
    
    const validate = useCallback(() => {
        if (token === undefined || token === null || token === "") {
            navigate('/login');
            return false;
        } else {
            return true;
        }
    }, [token, navigate]);

    return validate;
}